import React from 'react'
import { cn } from '../../design-system/utils'

/**
 * Page Transition Component
 * Provides smooth transitions between pages
 */
export const PageTransition = ({ children, className, ...props }) => {
  return (
    <div 
      className={cn(
        'transition-all duration-300 ease-in-out',
        className
      )} 
      {...props}
    >
      {children}
    </div>
  )
}

/**
 * Loading Transition Component
 * Shows loading state with smooth transitions
 */
export const LoadingTransition = ({ 
  isLoading, 
  fallback, 
  children, 
  className,
  ...props 
}) => {
  if (isLoading && fallback) {
    return fallback
  }
  
  if (isLoading) {
    return (
      <div className={cn('animate-pulse', className)} {...props}>
        {children}
      </div>
    )
  }
  
  return (
    <div className={cn('transition-opacity duration-300', className)} {...props}>
      {children}
    </div>
  )
}

export default { PageTransition, LoadingTransition }